import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import ReactHtmlParser from 'react-html-parser';
import _get from 'lodash/get';

const FlexibleHeadingParagraph = ({ data }) => {
    const title = _get(data, 'field_title', '');
    const Variant = _get(data, 'behavior_settings.lsy_heading.level', 'h1');
    const id = _get(data, 'behavior_settings.lsy_wrapper_attributes.id', '');
    const styles = id ? { scrollMarginTop: 120 } : {};

    return (
        <span key={uniqueId()} className={`paragraph__heading_${Variant}`}>
            <span className="clear"></span>
            <div className="flex-row">
                <Variant className="heading flex-100" id={id} style={styles}>
                    {ReactHtmlParser(title)}
                </Variant>
            </div>
        </span>
    );
};

FlexibleHeadingParagraph.propTypes = {
    data: PropTypes.objectOf(PropTypes.any),
};

export default FlexibleHeadingParagraph;
